import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertitiInitialWinCountUp} from "../initial/TombOfNefertitiInitialWinCountUp";
import {TombOfNefertitiFreeSpinTotalWinView} from "./TombOfNefertitiFreeSpinTotalWinView";

export class TombOfNefertitiFreeSpinTotalWinController extends WinPresentationController {

    private _view:TombOfNefertitiFreeSpinTotalWinView;
    private readonly _countUp:TombOfNefertitiInitialWinCountUp;

    private _countUpTl:Timeline | null;
    private _timeline:TimelineLite | null;

    private _isShowing:boolean = false;

    private _totalWin:number = 0;

    // #403
    private _totalWinBelowStake: boolean = false;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "FreeSpinTotalWin"});

        this._view = new TombOfNefertitiFreeSpinTotalWinView();

        this._countUp = new TombOfNefertitiInitialWinCountUp("FS_TOTAL_WIN");
        this._countUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.35);
        StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._countUp);
    }

    protected addFeatureEventHandlers():void {
        super.addFeatureEventHandlers && super.addFeatureEventHandlers();

        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, () => this.onFreeSpinOutroCompleting());
    }

    protected hasWin():boolean {
        this._gameData = this._gameData!;
        this._totalWin = this._gameData.totalWin;

        const retVal:boolean = (this._gameData.mode.indexOf(GameMode.FREESPIN) !== -1) && (this._gameData.nextMode.indexOf(GameMode.NORMAL) !== -1) && this._totalWin >= 0;

        // #403
        this._totalWinBelowStake = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this._totalWin <= this._gameData.playedBetValue));

        return retVal;
    }

    protected startWinPresentation():void {
        let tl:TimelineLite = new TimelineLite({
            onComplete : () => this.finish(),
            paused : true
        });

        this._isShowing = true;

        tl.add(() => {
            // #403
            if (!this._totalWinBelowStake) {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_INTRO_PAPER_OPEN);
            }
            TombOfNefertitiGameConfig.instance.FS_OUTRO_VISIBLE = true;
            this._view.startPresentation(this._totalWin, this._totalWinBelowStake);

            SlotGame.keypad.hide(); // #266
        });

        // #403
        if (!this._totalWinBelowStake && this._totalWin > 0) {
            tl.add(TweenLite.to(() => {}, 0.8, {}));

            tl.add(() => {
                this._countUp.scale.set(0.5);

                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.COUNT_UP, -1);

                const duration: number = 2;
                this._countUpTl = this._countUp.getCountUpAnimation(0, this._totalWin, duration, 1);
                TweenLite.to(this._countUp.scale, duration, {x: 1.5, y: 1.5});
                this._countUp.visible = true;
            });

            tl.add(TweenLite.to(() => {}, 2.3, {}));
        }

        this._timeline = tl;

        // #299 fix
        TweenLite.to(() => {}, this._gameData!.isBigWin ? 1 : 0, {
            onComplete : () => {
                EventHandler.dispatchEvent(new GameEvent("FORCE_HIDE_TOTAL_WIN"));
                this._timeline!.play();
            }
        });
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._view.stopPresentation();

        if(this._timeline && this._countUpTl && this._timeline!.isActive()) {
            this._timeline!.pause();
            this._timeline!.kill();
            this._timeline = null;

            this._countUpTl!.pause();
            this._countUpTl!.kill();
            this._countUpTl = null;
        }

        this._countUp.scale.set(1.5);
        this._countUp.visible = true;
        this._countUp.getCountUpAnimation(this._totalWin, this._totalWin, 0, 1);

        // #403
        if (!this._totalWinBelowStake) {
            SlotGame.sound.stopEffect(TombOfNefertitiSoundConfig.instance.COUNT_UP);
            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.INITIAL_WIN_COUNT_UP_END);
        }

        // #403
        let duration: number = (!this._totalWinBelowStake && this._totalWin > 0) ? 2 : 0;
        TweenLite.to(() => {}, duration, {
            onComplete : () => {
                TweenLite.to(this._countUp.scale, 0.05, {
                    x : 1, y : 1, onComplete : () => {
                        this._isShowing = true;
                        this._view.showTotalWinText(this._totalWinBelowStake);
                    }
                });
            }
        });
    }

    private onFreeSpinOutroCompleting():void {
        if(this._isShowing) {
            this._view.stopPresentation(); // #319
            this._view.onFreeSpinOutroCompleting();
            this._countUp.visible = false;

            this._isShowing = false;
        }
    }
}